<template>
  <div class="bbp-change-status">
    <i class="bbp-icon-cross bbp-change-status__cross" @click="closeForm"/>
    <div class="bbp-change-status__title" v-if="!displayText">{{statusName}}</div>
    <div class="bbp-change-status-body"
         :class="{
           'bbp-change-status-body_forward': isForward
         }">
      <div v-if="isDeclined">
        <div class="bbp-change-status-body__text">{{title}}</div>
        <div class="bbp-change-status-body__options">
          <BBPCheckbox
            v-for="option in optionsList"
            :key="option.id"
            :item="option"
            :title="option.text"
            :disable="option.disable"
            @change="changeCheckbox"
          />
          <BBPTextarea @input="inputOther"
                       :model="{other: ''}"
                       :input="{height: '85px', model: 'other', disabled: !this.checkedOther}"/>
        </div>
      </div>
      <div v-else-if="isForward">
        <div class="bbp-change-status-body__text bbp-change-status-body__text_info" v-if="displayText">
          You can close this request only once the invoice is paid by the client
        </div>
        <div class="bbp-change-status-body__text" v-else>
          Did client pay the invoice for this project?
        </div>
      </div>
    </div>
    <div class="bbp-change-status-footer" v-if="!displayText">
      <button class="bbp-button bbp-button_border bbp-button_border_gray" @click="closeForm">NO</button>
      <button class="bbp-button" @click="saveForm" :disabled="notSelected && isDeclined">YES</button>
    </div>
  </div>
</template>

<script>
import {find, get} from 'lodash'
import requestsStatuses, {DELAYED, IN_PROGRESS} from '@/constants/requestStatuses'
import BBPCheckbox from '@/components/Main/InputFields/BBPCheckbox/BBPCheckbox'
import BBPTextarea from '@/components/Main/BBPForm/BBPTextarea/BBPTextarea'
import {
  LOST_OPTIONS_DUPLICATE_ID,
  LOST_OPTIONS_OTHER_ID,
  LOST_OPTIONS_CLIENT_CHANGED_ID,
  LOST_OPTIONS_CLIENT_DECIDED_ID
} from '@/constants/lostOptions'

export default {
  name: 'RequestChangeStatus',
  components: {BBPTextarea, BBPCheckbox},
  props: ['statusId', 'options', 'title', 'isLostOptions'],
  data () {
    return {
      displayText: false,
      valueOther: '',
      checkedOther: false,
      checkedOptions: [],
      error: ''
    }
  },
  computed: {
    optionsList: {
      get () {
        return JSON.parse(JSON.stringify(this.options))
      },
      set (data) {
        this.$emit('update:options', data)
      }
    },
    currentStatus () {
      return find(requestsStatuses, {id: this.statusId}) || {}
    },
    statusName () {
      return get(this.currentStatus, 'title', '')
    },
    isDeclined () {
      return this.currentStatus.id === DELAYED.id
    },
    isForward () {
      return this.currentStatus.id === IN_PROGRESS.id
    },
    notSelected () {
      return this.checkedOptions.length === 0
    }
  },
  methods: {
    closeForm () {
      this.$emit('close')
    },
    saveForm () {
      if (this.notSelected && this.isDeclined) return
      if (this.isForward) {
        setTimeout(() => { this.displayText = true }, 200)
      }
      if (this.checkedOther) {
        const item = this.checkedOptions.find((el) => el.text === 'other')
        item.text = this.valueOther
      }
      this.$emit('save', this.isDeclined ? this.checkedOptions : false)
      this.defaultValueOptionsList()
    },
    inputOther (value) {
      this.valueOther = value
    },
    changeCheckbox ({value, item}) {
      if (item.text === 'other') this.checkedOther = value
      const index = this.checkedOptions.indexOf(item)
      if (value && index === -1) {
        this.checkedOptions.push(item)
      } else if (index !== -1) {
        this.checkedOptions.splice(index, 1)
      }
    },
    defaultValueOptionsList () {
      this.optionsList.forEach((el) => {
        el.disable = false
      })
    }
  },
  watch: {
    checkedOptions (newVal) {
      if (!this.isLostOptions) return
      const [firsItem = {}] = newVal
      const {id} = firsItem
      if (!id) {
        this.defaultValueOptionsList()
        return
      }
      this.optionsList.forEach((el) => {
        if (id === LOST_OPTIONS_CLIENT_CHANGED_ID || id === LOST_OPTIONS_CLIENT_DECIDED_ID) {
          el.disable = el.id === LOST_OPTIONS_DUPLICATE_ID || el.id === LOST_OPTIONS_OTHER_ID
        } else {
          el.disable = el.id === LOST_OPTIONS_CLIENT_CHANGED_ID || el.id === LOST_OPTIONS_CLIENT_DECIDED_ID
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../sass/variables";
  @import "../../../sass/mixins";

  .bbp-change-status {
    position: relative;
    width: 521px;
    height: auto;
    background-color: $color-white;
    border-radius: 8px;
    transition: 0.3s;

    &__cross {
      position: absolute;
      width: 20px;
      height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      top: 14px;
      right: 11px;
      color: $color-silver;
      font-size: 16px;
      transition: 0.3s;
      cursor: pointer;

      &:hover {
        color: $color-dusty-gray;
      }
    }

    &__title {
      padding: 14px 30px 14px 14px;
      font-style: normal;
      font-weight: 500;
      font-size: 17px;
      line-height: 20px;
      text-align: center;
    }

    &-body {
      padding: 11px 20px;

      &_forward {
        display: flex;
        align-items: center;
        justify-content: center;
        min-height: 84px;
      }

      &__text {
        font-style: normal;
        font-weight: normal;
        font-size: 15px;
        line-height: 18px;
        text-align: center;

        &_info {
          display: flex;
          align-items: center;
          justify-content: center;
          height: 157px;
        }
      }

      &__options {
        display: grid;
        grid-gap: 13px;
        margin: 16px 0 11px;
      }
    }

    &-footer {
      display: grid;
      grid-template-columns: 103px 103px;
      grid-gap: 12px;
      align-items: center;
      justify-content: end;
      padding: 18px;
      background: $color-alabaster;
      border-radius: 0 0 8px 8px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Requests/RequestChangeStatus/RequestChangeStatus.vue